export function isEmpty(obj) {
	return !obj || !/\S/.test(obj) || obj === "undefined" || obj === "null" || (obj instanceof Array && obj.length == 0) || (obj instanceof Object && JSON.stringify(obj) == "{}");
}

export function isNotEmpty(obj) {
	return !isEmpty(obj);
}

export function isMobile() {
	return !!navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
}

export function getRouterPath() {
	return !!navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
}

export function getApiDomain() {
	const parts = (window.location.hostname || '').split('.');
	const middle = parts.length >= 3 ? parts[1] : (parts[0] || '');
	return (process.env.VUE_APP_BASE_API || '').replace(/\*\*\*/g, middle);
}

export function getUploadDomain() {
	const host = window.location.hostname || '';
	const isLocal =
		host === 'localhost' ||
		host === '127.0.0.1' ||
		/^10\./.test(host) ||
		/^192\.168\./.test(host) ||
		/^172\.(1[6-9]|2\d|3[0-1])\./.test(host);
	// (process.env.NODE_ENV === 'development');
	if (isLocal) {
		return 'http://172.18.10.23:5086';
	}
	const parts = host.split('.');
	const middle = parts.length >= 3 ? parts[1] : (parts[0] || '');
	return (process.env.VUE_APP_UPLOAD_URL || '').replace(/\*\*\*/g, middle);
}

export function getActivityApiDomain() {
	const parts = (window.location.hostname || '').split('.');
	const middle = parts.length >= 3 ? parts[1] : (parts[0] || '');
	return (process.env.VUE_APP_ACTIVITY_API || '').replace(/\*\*\*/g, middle);
}

export function getGoogleAppClientId(env) {
	if (env == 'ea') {
		return process.env.VUE_APP_EA_GG_APP_ID;
	} else if (env == 'vn') {
		return process.env.VUE_APP_VN_GG_APP_ID;
	} else if (env == 'kr') {
		return process.env.VUE_APP_KR_GG_APP_ID;
	} else if (env == 'tw') {
		return process.env.VUE_APP_TW_GG_APP_ID;
	}
}

export function getCdnDomain(env) {
	if (env == 'ea') {
		return process.env.VUE_APP_SEA_CDN_DOMAIN;
	} else if (env == 'vn') {
		return process.env.VUE_APP_VN_CDN_DOMAIN;
	} else if (env == 'kr') {
		return process.env.VUE_APP_KR_CDN_DOMAIN;
	} else if (env == 'tw') {
		return process.env.VUE_APP_TW_CDN_DOMAIN;
	}
}

export function getHostDomain() {
	var url = new URL(window.location.href);
	var fullDomain = url.protocol + '//' + url.host;
	return fullDomain;
}

/**
 * 获取二级域名
 * 例如: xjlru-website.luckyyx.com -> luckyyx
 */
export function getSecondLevelDomain() {
	const hostname = window.location.hostname;
	const parts = hostname.split('.');
	// 倒数第二个部分就是二级域名
	return parts.length >= 2 ? parts[parts.length - 2] : 'luckyyx';
}

export function getUrlOwner() {
	const hostname = window.location.hostname;
	const parts = hostname.split('.');

	// 获取第一段（三级域名部分）
	const subdomain = parts[0];

	// 按 '-' 分割
	const segments = subdomain.split('-');
	if (segments.length === 3) {
		return segments[2];
	}
	// 其他情况返回默认值 'web'
	return 'web';
}

export const Base64 = {
	encode(str) {
		return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
			function toSolidBytes(match, p1) {
				return String.fromCharCode(Number('0x' + p1));
			}));
	},
	decode(str) {
		return decodeURIComponent(atob(str).split('').map(function (c) {
			return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
		}).join(''));
	}
}

/**
 * 计算返利百分比（包含优惠券加成）
 * @param {Object} rebate - 返利配置对象
 * @param {Object} goods - 商品对象
 * @param {string} productId - 商品ID
 * @param {Object} selectedCoupon - 选中的优惠券对象（可选）
 * @returns {number} 返利百分比
 */
export function calculateRebatePercent(rebate, goods, selectedCoupon = null) {
	// 如果rebate为空，但优惠券存在，直接返回优惠券的折扣
	if (!rebate && selectedCoupon && selectedCoupon.discountValue) {
		return parseInt(parseFloat(selectedCoupon.discountValue) * 100);
	}

	if (!rebate) return 0;

	// 获取商品特定返利或使用默认返利
	let goodsRebate = rebate.config && rebate.config[goods.productId];
	let baseRebate = isNotEmpty(goodsRebate) || goodsRebate == 0 ? goodsRebate : rebate.rebate;

	// 如果选中了优惠券，加上优惠券的折扣
	if (selectedCoupon && selectedCoupon.discountValue) {
		const goodsPrice = goods.amount || 0; // 商品价格
		const minAmount = parseFloat(selectedCoupon.minAmount); // 最小金额
		const maxAmount = parseFloat(selectedCoupon.maxAmount); // 最大金额
		if (
			selectedCoupon.limitedState === 1 &&
			(goodsPrice > maxAmount || goodsPrice < minAmount)
		) {
			return parseInt(baseRebate * 100); // 不叠加优惠券折扣
		}
		return parseInt((baseRebate + parseFloat(selectedCoupon.discountValue)) * 100);
	}

	return parseInt(baseRebate * 100);
}


export function isRebateApplicable(rebate, goods) {
	let productId = goods.productId;
	if (goods.isRebate === false) {
		return false;
	}
	return true;
}


export function formatDateTime(date = new Date()) {
	const pad = (n) => String(n).padStart(2, '0');
	return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
}

export async function checkOldActivityEnabled(axiosInstance, gameCode, date = new Date()) {
	try {
		const response = await axiosInstance({
			method: 'get',
			url: '/web/api/act/getOldActivity',
			params: {
				gameCode,
				date: typeof date === 'string' ? date : formatDateTime(date)
			}
		});

		return response && response.successful === true && response.data === true;
	} catch (err) {
		console.error('utils.checkOldActivityEnabled error', err);
		return false;
	}
}
